import React from 'react';
import { CTA_TYPE, CTA_SIZE } from '../../../data/constants';
import CtaComponent from '../../../components/reusable-ui/cta';
const ZeroScreen = (props: any) => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <img alt="icon" src={process.env.REACT_APP_CDN_ORACLE_URL + '/xml-icon.svg'}></img>
      <div className="black-color font-bold text-24 mt-[39px]">
        No Mapping Done
      </div>
      <div className="font-medium black-color opacity-50 mt-13">
        Create mapping first to generate XML files
      </div>
      <CtaComponent
        customClass="mt-24"
        ctaSize={CTA_SIZE.medium}
        onCtaClick={props.toggleMapping}
        ctaType={CTA_TYPE.active_cta}
        ctaText="+ Create Mapping"
      />
    </div>
  );
};
export default ZeroScreen;
